module.exports = __webpack_public_path__ + "img/EnergyIO.c6dd3fe5.png";